import React from 'react';
import {DeleteWithConfirmButton} from 'react-admin';

export default function DeleteWithConfirmation(props) {
  return (
    <DeleteWithConfirmButton confirmTitle={`Confirm delete "${props.record.name || props.record.report_name || props.record.adunit_code}"`} variant="contained" color="default" {...props} />
  )
};